<template>
  <v-app id="home" class="bg">
    <v-app-bar app flat color="transparent" class="mt-2">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" src="@/assets/rf-logo.png" contain />
      </template>
      <v-row height="10vh" no-gutters v-if="pages > 1">
        <v-btn dark fab @click="prev">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn dark fab @click="next">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-row>
    </v-app-bar>
    <v-main>
      <v-row no-gutters class="fill-height" align-content="center">
        <v-responsive class="align-center" :aspect-ratio="10 / 3">
          <v-window v-model="page">
            <v-window-item v-for="n in pages" :key="`page-${n}`">
              <v-row
                v-for="row in rows"
                :key="row"
                no-gutters
                class="game_row justify-space-around align-content-cen ter align-items-center"
              >
                <game
                  v-for="game in getGames(row)"
                  :key="game.name"
                  :game="game"
                  :provider="provider"
                  :casino="casino"
                />
              </v-row>
            </v-window-item>
          </v-window>
        </v-responsive>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
const Game = () => import("@/components/Game.vue");

export default {
  name: "Home",

  components: {
    Game,
  },
  created() {
    fetch(
      process.env.NODE_ENV === "production"
        ? `${process.env.BASE_URL}/casino.json`
        : "/data/casino.json",
      { cache: "force-cache" }
    )
      .then((response) => response.json())
      .then((data) => {
        this.games = data.games;
        this.casino = data.casinoUid;
      });
  },
  computed: {
    gamesPerPage() {
      return this.layoutRowNumber * this.layoutColumnNumber;
    },
    layoutColumnNumber() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 2;
        case "sm":
          return 3;
        case "md":
          return 4;
        case "lg":
          return 6;
        case "xl":
          return 8;
      }
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    numGames() {
      return Array.isArray(this.games) ? this.games.length : 0;
    },
    pageGames() {
      return this.pages
        ? Math.min(this.numGames - this.page * this.gamesPerPage, this.gamesPerPage)
        : 0;
    },
    pages() {
      return Math.ceil(this.numGames / this.gamesPerPage);
    },
    rows() {
      return Math.min(Math.ceil(this.pageGames / this.layoutColumnNumber), this.layoutRowNumber);
    },
  },
  data: () => ({
    casino: null,
    games: {},
    layoutRowNumber: 4,
    page: 0,
  }),
  methods: {
    getGames(row) {
      const a = (row - 1) * this.layoutColumnNumber + this.page * this.gamesPerPage;
      const b = row * this.layoutColumnNumber + this.page * this.gamesPerPage;
      return this.games.slice(a, b);
    },
    next() {
      this.page = this.page + 1 === this.pages ? 0 : this.page + 1;
    },
    prev() {
      this.page = this.page - 1 < 0 ? this.pages - 1 : this.page - 1;
    },
  },
};
</script>

<style scoped>
.game_row {
  height: 20vh;
}
.v-main__wrap {
  z-index: 10;
}
</style>
